import React from "react";

const ReactionHistory = ({ item }) => {
  return <p>reaction history</p>;
};

export default ReactionHistory;
